"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHREventDrivenClient = void 0;
var XHREventDrivenClient_1 = require("./XHREventDrivenClient");
Object.defineProperty(exports, "XHREventDrivenClient", { enumerable: true, get: function () { return XHREventDrivenClient_1.XHREventDrivenClient; } });
//# sourceMappingURL=index.js.map